export default __webpack_public_path__ + "static/media/profile.52db864b.png";